var _path, _rect, _path2, _path3, _rect2, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _path5, _rect8, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAdapter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 199,
    viewBox: "0 0 108 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 33C68.5 31.067 70.067 29.5 72 29.5L100 29.5C101.933 29.5 103.5 31.067 103.5 33L103.5 44.5L68.5 44.5L68.5 33Z",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 44.5,
    width: 43,
    height: 41,
    rx: 3.5,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 17C73.5 16.1716 74.1716 15.5 75 15.5C75.8284 15.5 76.5 16.1716 76.5 17L76.5 29.5L73.5 29.5L73.5 17Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5 17C95.5 16.1716 96.1716 15.5 97 15.5C97.8284 15.5 98.5 16.1716 98.5 17L98.5 29.5L95.5 29.5L95.5 17Z",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 91.5,
    width: 18,
    height: 21,
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 91.5L85.5 113",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 97.5,
    width: 3,
    height: 3,
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 97.5,
    width: 3,
    height: 3,
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 103.5,
    width: 24,
    height: 28,
    rx: 3.5,
    fill: "white",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 131.5,
    width: 11,
    height: 5,
    rx: 1.5,
    fill: "white",
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 98,
    width: 5,
    height: 7,
    rx: 2,
    transform: "rotate(90 10 98)",
    fill: "white",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 117L10 124C10 124.552 9.55228 125 9 125L4 125C3.44771 125 3 124.552 3 124L3 117L10 117Z",
    fill: "white",
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 103,
    width: 15,
    height: 11,
    rx: 3,
    transform: "rotate(90 12 103)",
    fill: "white",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 5C15.1038 5 8.5 11.6038 8.5 19.75V98.5H4.5V19.75C4.5 9.39466 12.8947 1 23.25 1C33.6053 1 42 9.39466 42 19.75V174C42 185.322 51.1782 194.5 62.5 194.5C73.8218 194.5 83 185.322 83 174V136.5H87V174C87 187.531 76.031 198.5 62.5 198.5C48.969 198.5 38 187.531 38 174V19.75C38 11.6038 31.3962 5 23.25 5Z",
    fill: "white",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 118V125",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdapter);
export default __webpack_public_path__ + "static/media/ic-adapter.9153639010e0bd845480567c33b53154.svg";
export { ForwardRef as ReactComponent };